import React, { Component } from 'react'
import Header from '../Header'
import './IIw.css'

class IIw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyIIw">
                    <p className="textIIw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default IIw